import { createActionFactory } from '../../common/redux';

const { createAction } = createActionFactory('Experience Workspace => Workspace => ');

const changeExperienceType = createAction('change experience type', experience => ({ experience }));

// TODO Does this belong here?
const launchScreenDesigner = createAction(
  'launch screen designer',
  ({
    displayType,
    editorMode,
    editorView,
    experienceId,
    editedLayoutIds,
    activeLayoutId,
    themeId,
    canUseForms,
    designerType,
  }) => ({
    displayType,
    editorMode,
    editorView,
    experienceId,
    editedLayoutIds,
    activeLayoutId,
    themeId,
    canUseForms,
    designerType,
  })
);

const decorateWorkspaceWithUser = createAction('decorate the active workspace with the current user', user => ({
  user,
}));

export default {
  changeExperienceType,
  launchScreenDesigner,
  decorateWorkspaceWithUser,
};
